'use strict';

const {degToRad} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('gap-square', function () {
    let sideLength = this.width - this.pad * 2;

    let shape = new Shape(4, sideLength, new Point(this.pad + sideLength, this.pad + sideLength));
    shape.dotSize = 0.5;
    shape.dumbSquare = true;

    shape.draw(this.ctx);
    shape.setFractalProportion(0.51);

    this.addRunButton(shape, 50000);
});


